import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents-list-icon" }
const _hoisted_3 = { class: "contents-list-icon-main" }
const _hoisted_4 = { class: "contents-profile-setting" }
const _hoisted_5 = { class: "contents-profile-setting-input-password" }
const _hoisted_6 = { class: "input-section" }
const _hoisted_7 = { class: "password-wrapper" }
const _hoisted_8 = ["type"]
const _hoisted_9 = { class: "attention" }
const _hoisted_10 = { class: "contents-profile-setting-button" }

import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { processing, processend } from "@/utils/view";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import { _$t } from "@/utils/i18n";
import { Password } from "@/models/profile/password";

import CommonMessage from "@/views/base/CommonMessage.vue";

// ---- Constant ----------------------------------------------
const componentId = "generalpurpose04-03-a";
const menuId = "profile";

export default /*@__PURE__*/_defineComponent({
  __name: 'Password',
  setup(__props) {

const router = useRouter();
const passwordModel = new Password();
const isError = ref(false);
const isSessionError = ref(false);
const fieldErrors = ref<Record<string, string>>({});

// ---- Variable ----------------------------------------------
let password = ref("");
let result = ref("");
let isConfirmShow = ref(false);
let showPassword = ref(false);

// ----- Function -----------------------------------------------
// メッセージダイアログ関連情報
let messageConfig = reactive({
  show: false,
  okButtonHide: true,
  cancelButton: false,
  safe: false,
  cancelName: _$t("button_cancel_label"),
  message: "",
  open: (message: string, cancelButton: boolean): void => {
    processing();
    messageConfig.message = message;
    messageConfig.show = true;
    messageConfig.cancelButton = cancelButton;
  },
  close: async () => {
    processend();
    messageConfig.show = false;
    if (isConfirmShow.value) {
      // パスワード変更
      changePassword();
      // messageConfig.show = false;
    } else if (isSessionError.value) {
      messageConfig.message = "";
      window.location.href = "/cms/login";
    } else if (!isError.value) {
      messageConfig.message = "";
      // 画面遷移
      router.push({ name: "Profile" });
    }
  },
  cancel: (): void => {
    processend();
    messageConfig.show = false;
  },
});

// キャンセルボタン押下
const cancel = () => {
  router.push({ name: "Profile" });
};

// パスワードバリデーションチェック
const validatePassword = async () => {
  let message = "";
  // バリデーション
  passwordModel.set({
    password: password.value ? password.value : undefined,
  });

  const validateResult: any = passwordModel.validate();
  fieldErrors.value = {};
  if (!validateResult.valid) {
    validateResult.errors.forEach((error: { key: string; msg: string }) => {
      fieldErrors.value[error.key] = error.msg;
    });
  }

  if (Object.keys(fieldErrors.value).length > 0) {
    isError.value = true;
    return;
  }

  // バリデーションチェック後、初期化
  isError.value = false;

  // パスワード変更確認メッセージダイアログを表示する
  message = _$t("changePassword_confirm_text");
  isConfirmShow = ref(true);
  messageConfig.open(message, true);
};

// パスワード更新
const changePassword = async () => {
  let message = "";
  isConfirmShow = ref(false);

  await passwordModel.updateData().then(([model, _response, err]) => {
    if (err) {
      if (err.error.response.status === 408) {
        isSessionError.value = true;
      } else {
        isError.value = true;
      }
      message = decodeURI(err.error.response.data.message);
      messageConfig.open(message, false);
      return;
    } else {
      message = _$t("changePassword_modal_text");
      result.value = JSON.stringify(model.attributes.result, null, 2);
      // モーダル表示
      messageConfig.open(message, false);
    }
  });
};

// パスワード目アイコンを押下
const togglePassword = () => {
  showPassword.value = !showPassword.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, { activeMenu: menuId }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("profile_change_password")), 1),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "contents-list-icon-tri" }, null, -1))
          ]),
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", _hoisted_4, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("changePassword_text_newPassword")), 1),
                _createElementVNode("td", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("input", {
                        type: _unref(showPassword) ? 'text' : 'password',
                        class: "input-password",
                        id: "password",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event))
                      }, null, 8, _hoisted_8), [
                        [_vModelDynamic, _unref(password)]
                      ]),
                      _createElementVNode("span", {
                        class: "material-icons toggle-password",
                        onClick: togglePassword
                      }, _toDisplayString(_unref(showPassword) ? "visibility" : "visibility_off"), 1)
                    ]),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("changePassword_label_attention")), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-required-error", fieldErrors.value.password ? 'active' : ''])
                  }, _toDisplayString(fieldErrors.value.password), 3)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: "password-cansel-button",
              onClick: cancel
            }, _toDisplayString(_ctx.$t("button_cancel_label")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "password-change-button",
              onClick: validatePassword
            }, _toDisplayString(_ctx.$t("changePassword_button_submit")), 1)
          ])
        ]),
        _createVNode(Footer, { "scroll-target": componentId })
      ])
    ]),
    (_unref(messageConfig).show)
      ? (_openBlock(), _createBlock(CommonMessage, _mergeProps({ key: 0 }, _unref(messageConfig), {
          onOk: _unref(messageConfig).close,
          onCancel: _unref(messageConfig).cancel
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})